import React, { useState } from "react";
import { FaPhone, FaEnvelope, FaCopyright } from "react-icons/fa";
import { BsBank2 } from "react-icons/bs";
import { HiMiniBuildingOffice } from "react-icons/hi2";
import styles from "./index.module.css";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import KakaoLoginButton from "../../components/Kakao";
import Instagram from "components/Button/Instagram";
import Interact from "img/Interact.png";
import PayPal from "img/PayPal_small.svg";
import Flag from "react-world-flags";
import { Link } from "react-router-dom";

const Footer = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const bankInfo = {
        beneficiaryBank: "Bank of Montreal",
        branchName: "Fifth Avenue Place Branch",
        beneficiaryBankAddress:
            "425 1st Street S.W., Suite 113, Calgary, AB T2P 3L8",
        institutionCode: "001",
        transitNumber: "06779",
        routingNo: "000106779",
        accountNumber: "0677 1987-779",
        swiftBIC: "ROYCCAT2CIC",
        beneficiaryName: "16811540 CANADA INC.",
        beneficiaryAddress: "205-301 14 ST NW ROOM 2, Calgary, Alberta T2N 1Z7",
    };

    return (
        <div className={styles.background}>
            <div className={styles.footerTopBg}>
                <div className={styles.footerTop}>
                    <Link to={`/attention`}>{t("Attention")}</Link>
                    <span className={styles.arrow}>|</span>
                    <Link to={`/contact`}>{t("ContactUs")}</Link>
                    <span className={styles.arrow}>|</span>
                    <Link to={`/tandc`}>{t("TandC")}</Link>
                    <span className={styles.arrow}>|</span>
                    <Link to={`/privacy`}>{t("Privacy")}</Link>
                </div>
            </div>
            <div className={styles.footerContainer}>
                <div className={styles.left}>
                    <div className={styles.logoText}>{t("Logo")} &nbsp;</div>
                    <div>
                        <span className={styles.logoButtons}>
                            <KakaoLoginButton />
                            <Instagram />
                        </span>
                    </div>
                    <div className={styles.phoneDiv}>{t("CEOPhone")}</div>
                    <span>
                        <HiMiniBuildingOffice /> 205 - 301 14 St NW, Calgary, AB
                        T2N 1Z7
                    </span>
                    <span>
                        <FaEnvelope />{" "}
                        <a href="mailto:info@lolotour.com">info@lolotour.com</a>
                    </span>
                    <span className={styles.bankInfoForMobile}>
                        <BsBank2 />{" "}
                        <a href="#" onClick={() => setOpen(true)}>
                            {t("AccountInfo")}
                        </a>
                    </span>
                </div>
                <div className={styles.right}>
                    <div className={styles.phoneDiv}>
                        {t("InteractAddress")}
                    </div>
                    <div className={styles.interactInfo}>
                        <div className={styles.paymentsContainer}>
                            <div className={styles.payments}>
                                <img src={PayPal} alt="PayPal" />
                                <img src={Interact} alt="Interact" />
                            </div>
                            <div className={styles.paypalEmail}>
                                {t("Interact")}
                            </div>
                        </div>
                    </div>
                    <div className={styles.busineseDiv}>{t("AccountInfo")}</div>
                    <Flag
                        code="ca"
                        height="16"
                        style={{
                            marginBottom: "3px",
                        }}
                    />
                    {Object.entries(bankInfo).map(([key, value]) => (
                        <p key={key}>
                            <strong>{t(key)}:</strong> {value}
                        </p>
                    ))}
                </div>
            </div>
            <div className={styles.footerTxt}>
                <FaCopyright /> {t("Logo")} - All rights reserved.
            </div>
            <Modal centered show={open} onHide={handleClose}>
                <Modal.Body>
                    <div className={styles.modalBankContainer}>
                        <h4>{t("AccountInfo")}</h4>
                        <Flag
                            code="ca"
                            height="16"
                            style={{ border: "1px solid white" }}
                        />
                        {Object.entries(bankInfo).map(([key, value]) => (
                            <p key={key}>
                                <strong>{t(key)}:</strong> {value}
                            </p>
                        ))}
                        <button
                            className="myButton cancel right"
                            onClick={handleClose}
                        >
                            {t("Close")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Footer;
